// import './client-polyfills.es6';
import './alert.es6';
import './js/main.es6';

// check mondux or intra2016 projects to see usage
const pages = require.context('./pages/', true, /index\.es6$/);
// const parts = require.context('./parts/', true, /index\.es6$/);
pages.keys().forEach(pages);
// parts.keys().forEach(parts);
